/**
 * kw-analytics.js — GA4 + Meta Pixel + Pinterest Tag scaffolding.
 *
 * IDs are provided via `window.KW_ANALYTICS = { ga4: 'G-XXXXX', meta: '123456', pin: '2612345' }`
 * — set by kw-analytics-config.liquid so the theme editor can control it.
 *
 * Skips loading vendor libs when a given ID is blank; no wasted requests.
 * Wires standard e-commerce events:
 *   - PageView (auto)
 *   - ViewContent  (PDP)
 *   - AddToCart    (form submit on PDP)
 *   - InitiateCheckout (checkout link click)
 *   - AddToFavorites  (custom event dispatched by kw-favorites.js)
 *   - NewsletterSignup (custom event dispatched by kw-newsletter.js)
 */
(function () {
  var cfg = window.KW_ANALYTICS || {};
  var ga4 = cfg.ga4;
  var meta = cfg.meta;
  var pin = cfg.pin;
  var loaded = { ga4: false, meta: false, pin: false };

  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src; s.async = true;
    if (cb) s.onload = cb;
    document.head.appendChild(s);
  }

  // ---------- GA4 ----------
  function initGa4() {
    if (!ga4 || loaded.ga4) return;
    loaded.ga4 = true;
    loadScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ga4));
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    gtag('js', new Date());
    gtag('config', ga4, { send_page_view: true, anonymize_ip: true });
  }

  // ---------- Meta Pixel ----------
  function initMeta() {
    if (!meta || loaded.meta) return;
    loaded.meta = true;
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = true; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', meta);
    fbq('track', 'PageView');
  }

  // ---------- Pinterest Tag ----------
  function initPin() {
    if (!pin || loaded.pin) return;
    loaded.pin = true;
    !(function (e) {
      if (!window.pintrk) {
        window.pintrk = function () { window.pintrk.queue.push(Array.prototype.slice.call(arguments)); };
        var n = window.pintrk;
        n.queue = []; n.version = '3.0';
        var t = document.createElement('script'); t.async = true; t.src = e;
        var r = document.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(t, r);
      }
    })('https://s.pinimg.com/ct/core.js');
    pintrk('load', pin);
    pintrk('page');
  }

  function track(evName, params) {
    params = params || {};
    if (ga4 && window.gtag) window.gtag('event', evName, params);
    if (meta && window.fbq) {
      var metaMap = {
        page_view: 'PageView',
        view_item: 'ViewContent',
        add_to_cart: 'AddToCart',
        begin_checkout: 'InitiateCheckout',
        add_to_wishlist: 'AddToWishlist',
        sign_up: 'CompleteRegistration',
      };
      window.fbq('track', metaMap[evName] || evName, params);
    }
    if (pin && window.pintrk) {
      var pinMap = {
        view_item: 'pagevisit',
        add_to_cart: 'AddToCart',
        begin_checkout: 'Checkout',
        sign_up: 'Signup',
      };
      window.pintrk('track', pinMap[evName] || 'custom', params);
    }
  }

  // ---------- E-commerce event wiring ----------
  function readProduct() {
    // Prefer JSON-LD Product schema (already emitted by theme)
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        var p = d['@type'] === 'Product' ? d : (Array.isArray(d['@graph']) ? d['@graph'].find(function (g) { return g['@type'] === 'Product'; }) : null);
        if (p) {
          var offers = Array.isArray(p.offers) ? p.offers[0] : p.offers;
          return {
            item_id: p.sku || p.productID || p.mpn || p.name,
            item_name: p.name,
            price: offers && parseFloat(offers.price || 0),
            currency: (offers && offers.priceCurrency) || 'USD',
          };
        }
      } catch (e) {}
    }
    return null;
  }

  function wirePdp() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var p = readProduct();
    if (p) track('view_item', { items: [p], value: p.price, currency: p.currency });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"], form.shopify-product-form')) return;
      var pp = readProduct();
      if (pp) track('add_to_cart', { items: [pp], value: pp.price, currency: pp.currency });
    }, true);
  }

  function wireCheckoutLink() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/checkout"], button[name="checkout"]');
      if (!a) return;
      track('begin_checkout', {});
    });
  }

  function wireFavorites() {
    document.addEventListener('kw:favorite-added', function (e) {
      track('add_to_wishlist', e.detail || {});
    });
  }

  function wireNewsletter() {
    document.addEventListener('kw:newsletter-signup', function () {
      track('sign_up', { method: 'newsletter' });
    });
  }

  function init() {
    if (!ga4 && !meta && !pin) return; // no IDs, no libs, no requests
    initGa4();
    initMeta();
    initPin();
    wirePdp();
    wireCheckoutLink();
    wireFavorites();
    wireNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
